import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
    displayableCashback,
    hasCashback,
    isMultiDiscount,
    isMultiDiscountOffline,
    hasCashbackOffline,
    renderPluralConditional,
    hasEbon,
    hasEbonCashback
} from '../../services/partner/utils';
import { EBON_CUMUL_ON_PARTNER_BLOCKS } from '../../services/partner/constants';
import { hasBilletteriePrice } from '../../services/billetterie/utils';

import BilletteriePriceComponent from './BilletteriePriceComponent';

class CashbackBlocPartenaireComponent extends React.Component {
    pluralCondFunc = mdd => mdd && (mdd.fixed > 1 || mdd.percent > 1);

    renderJusqua = (partner, isOffline, i18n) =>
        (!isOffline && isMultiDiscount(partner)) ||
        (isOffline && isMultiDiscountOffline(partner)) ? (
            <div className="jusqua small">{i18n.jusqua}</div>
        ) : (
            <div className="jusqua small">&nbsp;</div>
        );

    renderDisplayCashback = (percent, fixed) => (
        <strong>{`${displayableCashback(percent, fixed)} `}</strong>
    );

    renderCashback = discount => {
        const { percent, fixed } = discount;
        return this.renderDisplayCashback(percent, fixed);
    };

    renderInsteadOf = (i18n, discount) => {
        const { initialPercent, initialFixed } = discount;

        if (initialPercent > 0 || initialFixed > 0) {
            return (
                <div className="small aulieu">
                    {`${i18n.aulieude} ${displayableCashback(initialPercent, initialFixed)}`}
                </div>
            );
        }
        return <div className="small aulieu">&nbsp;</div>;
    };

    renderEbonCashbackCumul = () => {
        const { ebonCbCumulable } = this.props;
        return ebonCbCumulable;
    };

    // Mêmes emplacements que les autres types, pour l'alignement des grilles mixtes
    renderBilletterie = (partner, i18n, cssClassContainer) => {
        const withPrice = hasBilletteriePrice(partner);
        const ebonCashback = hasEbonCashback(partner) && partner.ebonDiscount.cashback;

        return (
            <div className={`${cssClassContainer}`}>
                <div className="jusqua small">{withPrice ? i18n.FROM_PRICE : ' '}</div>
                {withPrice ? (
                    <p className="valeur">
                        <BilletteriePriceComponent partner={partner} />
                    </p>
                ) : ebonCashback ? (
                    <p className="valeur">
                        {this.renderDisplayCashback(
                            ebonCashback.percent.value,
                            ebonCashback.fixed.value
                        )}
                        <span>
                            {renderPluralConditional(i18n.offert, () =>
                                this.pluralCondFunc({
                                    percent: ebonCashback.percent.value,
                                    fixed: ebonCashback.fixed.value
                                })
                            )}
                        </span>
                    </p>
                ) : (
                    <p className="valeur">{i18n.TICKETING}</p>
                )}
                <span className="immediately">
                    {!withPrice && ebonCashback ? i18n.IMMEDIATELY : ' '}
                </span>
                <div className="small aulieu">&nbsp;</div>
                {EBON_CUMUL_ON_PARTNER_BLOCKS && <div className="ebonCumul">&nbsp;</div>}
            </div>
        );
    };

    renderNoCashback = (i18n, cssClassContainer) => (
        <div className={`${cssClassContainer} flex-container-v`}>
            <div className="small nocashback">{i18n.pasdecashbackencemoment}</div>
        </div>
    );

    renderConditional = (partner, i18n, cssClassContainer, isOffline, discount, isEbon) => {
        if (
            (partner && hasCashback(partner) && !isOffline) ||
            (hasCashbackOffline(partner) && isOffline) ||
            (hasEbon(partner) && isEbon)
        ) {
            const mostDisplayableDiscount = isOffline
                ? partner.mostDisplayableDiscountOffline
                : isEbon
                ? {
                      fixed: partner.ebonDiscount.cashback.fixed.value,
                      percent: partner.ebonDiscount.cashback.percent.value,
                      initialPercent: partner.ebonDiscount.cashback.percent.initialValue
                  }
                : partner.mostDisplayableDiscountOnline;
            const forcedDiscount =
                !!discount && discount.partnerId === partner.id && discount.cashback;
            const displayableDiscount = forcedDiscount ? forcedDiscount : mostDisplayableDiscount;
            // Offre Qwertys (en ligne uniquement) : « de remise immédiate »
            // (invariable) remplace « remboursé(s) ».
            const isQwertys = !isEbon && !isOffline && !!partner.qwertys;

            return (
                <div className={`${cssClassContainer}`}>
                    {/* Chaque type d'offre rend les mêmes emplacements (jusqu'à,
                        valeur, immédiatement, au lieu de, cumul), quitte à laisser
                        une ligne vide : les textes et boutons des blocs restent
                        alignés entre eux dans les grilles qui mixent les types. */}
                    {isEbon ? (
                        <div className="jusqua small">&nbsp;</div>
                    ) : (
                        this.renderJusqua(partner, isOffline, i18n)
                    )}
                    <p className={`valeur${isQwertys ? ' immediate-discount' : ''}`}>
                        {this.renderCashback(displayableDiscount)}
                        <span>
                            {isQwertys
                                ? i18n.IMMEDIATE_DISCOUNT
                                : renderPluralConditional(
                                      isEbon ? i18n.offert : i18n.rembourse,
                                      () => this.pluralCondFunc(displayableDiscount)
                                  )}
                        </span>
                    </p>

                    {isEbon ? (
                        <span className="immediately">{i18n.IMMEDIATELY}</span>
                    ) : (
                        <span className="immediately">&nbsp;</span>
                    )}
                    {this.renderInsteadOf(i18n, displayableDiscount)}
                    {EBON_CUMUL_ON_PARTNER_BLOCKS &&
                        (isEbon && this.props.ebonCbCumulable ? (
                            this.renderEbonCashbackCumul()
                        ) : (
                            <div className="ebonCumul">&nbsp;</div>
                        ))}
                </div>
            );
        } else {
            return this.renderNoCashback(i18n, cssClassContainer);
        }
    };

    render() {
        const { i18n, partner, cssClassContainer, isOffline, discount, isEbon, isBilletterie } =
            this.props;
        if (isBilletterie) {
            return this.renderBilletterie(partner, i18n, cssClassContainer);
        }
        return this.renderConditional(
            partner,
            i18n,
            cssClassContainer,
            isOffline,
            discount,
            isEbon
        );
    }
}

CashbackBlocPartenaireComponent.propTypes = {
    partner: PropTypes.object.isRequired,
    i18n: PropTypes.object.isRequired,
    cssClassContainer: PropTypes.string.isRequired,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool,
    isBilletterie: PropTypes.bool,
    ebonCbCumulable: PropTypes.object,
    discount: PropTypes.object
};

const mapStateToProps = state => ({
    i18n: state.i18n.feature.partenaire
});

export default connect(mapStateToProps)(CashbackBlocPartenaireComponent);



// WEBPACK FOOTER //
// ./src/components/partner/CashbackBlocPartenaireComponent.js